import React from 'react';

import styled from 'styled-components';

import { Color } from '@assets/constants';
import { icons } from '@assets/icons';
import { ReactComponent as Logo } from '@assets/images/logo.svg';
import { useCustomNavigate } from '@hooks';

const socialMediaLinks = {
  facebook: 'https://www.facebook.com/teniskitevarna',
  tiktok: 'https://www.tiktok.com/@teniskivarna',
  instagram: 'https://www.instagram.com/teniskivarna',
  youtube: 'https://www.youtube.com/@teniskivarna'
};

const navigationItems = [
  { name: 'Общи условия', path: '/terms-and-conditions' },
  { name: 'Политика за Личните Данни', path: '/privacy-policy' },
  { name: 'Обратна връзка', path: '/feedback' }
];

interface NavigationItemsProps {
  navigate: (path: string) => void;
}

const NavigationItems = ({ navigate }: NavigationItemsProps) => {
  return (
    <>
      {navigationItems.map((item, index) => (
        <NavigationItem onClick={() => navigate(item.path)} key={index}>
          {item.name}
        </NavigationItem>
      ))}
    </>
  );
};

export const Footer = () => {
  const navigate = useCustomNavigate();

  const navigateToSocialMedia = (url: string) => window.open(url, '_blank');

  return (
    <FooterWrapper>
      <InnerWrapper>
        <NavigationWrapper>
          <NavigationItems navigate={navigate} />
        </NavigationWrapper>

        <ContactWrapper>
          <Text>Контакти</Text>
          <Contacts>
            <ContactRow>
              <icons.FaMapMarkerAlt size={16} color={Color.DARK_GRAY} />
              <TinyText>
                гр. Варна, бул. Сливница 185, ет. 0, срещу Costa кафе
              </TinyText>
            </ContactRow>
            <ContactRow>
              <icons.FaAt size={16} color={Color.DARK_GRAY} />
              <SmallText>teniski.varna2022@gmail.com</SmallText>
            </ContactRow>
            <ContactRow>
              <icons.FaPhone size={16} color={Color.DARK_GRAY} />
              <SmallText>088 822 8975</SmallText>
            </ContactRow>
          </Contacts>

          <SocialMediaWrapper>
            <SocialMediaIconWrapper
              onClick={() => navigateToSocialMedia(socialMediaLinks.facebook)}
            >
              <icons.FaFacebookF size={20} color={Color.ACCENT} />
            </SocialMediaIconWrapper>
            <SocialMediaIconWrapper
              onClick={() => navigateToSocialMedia(socialMediaLinks.tiktok)}
            >
              <icons.FaTiktok size={20} color={Color.ACCENT} />
            </SocialMediaIconWrapper>
            <SocialMediaIconWrapper
              onClick={() => navigateToSocialMedia(socialMediaLinks.instagram)}
            >
              <icons.FaInstagram size={20} color={Color.ACCENT} />
            </SocialMediaIconWrapper>
            <SocialMediaIconWrapper
              onClick={() => navigateToSocialMedia(socialMediaLinks.youtube)}
            >
              <icons.FaYoutube size={20} color={Color.ACCENT} />
            </SocialMediaIconWrapper>
          </SocialMediaWrapper>
          <SmallText>© Тениски Варна 2024</SmallText>
        </ContactWrapper>

        <LogoWrapper onClick={() => navigate('/')}>
          <Logo />
        </LogoWrapper>
      </InnerWrapper>
    </FooterWrapper>
  );
};

const Contacts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin: 8px 0 8px 0;
`;

const ContactRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 8fr;
  gap: 5px;
`;

const SocialMediaIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Color.DARK_GRAY};
  border-radius: 50%;
  padding: 5px;
`;

const SocialMediaWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 8px;
`;

const TinyText = styled.p`
  font-size: 10px;

  @media (min-width: 1024px) {
    font-size: 12px;
  }
`;

const SmallText = styled.p`
  font-size: 12px;

  @media (min-width: 1024px) {
    font-size: 14px;
  }
`;

const Text = styled.p`
  font-size: 14px;

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

const NavigationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const NavigationItem = styled.p`
  font-size: 12px;
  cursor: pointer;

  @media (min-width: 1024px) {
    font-size: 14px;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  cursor: pointer;

  svg {
    width: 3.5rem;
  }

  @media (min-width: 1024px) {
    svg {
      width: 5rem;
    }
  }
`;

const InnerWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  width: 100%;
  max-width: 1200px;
  align-self: center;
`;

const FooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100svw;
  padding: 1rem 1.5rem;
  color: ${Color.DARK_GRAY};
  background-color: ${Color.ACCENT};
`;
